import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { CustomerDataState } from './customerData.types';

import { DEFAULT_SAVE_ACTION, SaveActionType } from '~/core/constants';
import { CustomerDataModel } from '~/core/models';

const initialState: CustomerDataState = {
  selectedCustomerData: {
    subject: '',
    confirmName: false,
    confirmAddress: false,
    customerName: '',
    email: '',
    phone: '',
    alternatePhone: '',
    address1: '',
    city: '',
    state: '',
    zip: '',
    sendCustomerEmail: true,
  },
  saveAction: DEFAULT_SAVE_ACTION,
};

const customerDataSlice = createSlice({
  name: 'customerData',
  initialState,
  reducers: {
    updateSelectedCustomerData: (
      state,
      action: PayloadAction<CustomerDataModel>
    ) => {
      state.selectedCustomerData = action.payload;
    },
    updateSaveAction: (state, action: PayloadAction<SaveActionType>) => {
      state.saveAction = action.payload;
    },
    resetSelectedCustomerData: (state) => {
      state.selectedCustomerData = initialState.selectedCustomerData;
    },
  },
});

export const {
  updateSelectedCustomerData,
  updateSaveAction,
  resetSelectedCustomerData,
} = customerDataSlice.actions;

export default customerDataSlice.reducer;
